import React from 'react';
import { connect } from 'react-redux';
import "./styles.css";

class Component extends React.Component {

    constructor(props){
        super(props);
    }

    render() {
        return(
            <React.Fragment>
                <div className='pubCard'>
                    <img className='pubCardImage' src={process.env.PUBLIC_URL+ "/img/"+this.props.img}/>
                    <div className='pubCardContent'>
                        <div className='pubCardTitle'>
                            {this.props.title}
                        </div>
                        <div className='pubCardAuthor'>
                            {this.props.authorsFirstPart} <b>Calvin Ku</b> {this.props.authorsSecondPart}
                        </div>
                        <div className='pubCardConferece'>
                            {this.props.conference}
                        </div>
                        <div className='pubCardSummary'>
                            {this.props.summary}
                        </div>
                        <a href= {this.props.link} style={{fontSize: "14px", textDecoration: "underline", color: "white"}}>
                            ⬇️ Read my paper
                        </a>
                        
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const Redux = connect(store => ({

}))(Component);

export const PublicationCardComponent = Redux;